import type { RouteRecordRaw } from "vue-router";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import {
	navigationGuardForDirectToCustomer,
	navigationGuardForDirectToCustomerWelcome,
} from "@/apps/merchant3/helpers/navigationGuards";
import { merchant3TranslationGuard } from "@/router/translationGuards";

// Lazy-loaded view components for code splitting
const DirectToCustomerWelcomeView = () =>
	import("@/apps/merchant3/views/DirectToCustomerWelcomeView.vue");
const DirectToCustomerTermsAndConditionsView = () =>
	import(
		"@/apps/merchant3/components/customer-registration/views/DirectToCustomerTermsAndConditionsView.vue"
	);
const DirectToCustomerOfferSummaryView = () =>
	import("@/apps/merchant3/views/DirectToCustomerOfferSummaryView.vue");

export const directToCustomerRoutes: Array<RouteRecordRaw> = [
	// New URL structure: /:countryCode/d2c/*
	{
		path: "/:countryCode/d2c",
		name: RouteName.DirectToCustomerWelcome,
		component: DirectToCustomerWelcomeView,
		beforeEnter: [
			navigationGuardForDirectToCustomerWelcome,
			merchant3TranslationGuard,
		],
	},
	{
		path: "/:countryCode/d2c/offer-summary",
		name: RouteName.DirectToCustomerOfferSummary,
		component: DirectToCustomerOfferSummaryView,
		beforeEnter: [
			navigationGuardForDirectToCustomer,
			merchant3TranslationGuard,
		],
	},
	{
		path: "/:countryCode/d2c/customer-registration/terms-conditions",
		name: RouteName.DirectToCustomerTermsAndConditions,
		component: DirectToCustomerTermsAndConditionsView,
		beforeEnter: [
			navigationGuardForDirectToCustomer,
			merchant3TranslationGuard,
		],
	},
];
